<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column
            h3.is-size-3 
              span
                | Agregar Consumibles para {{ consumibleSelected.subcategoria === '' ? consumibleSelected.categoria : `${consumibleSelected.categoria} - ${consumibleSelected.subcategoria}` }} |&nbsp
                small {{ consumibleSelected.modelo }}
                | &nbsp
                a.button.is-black.is-rounded(@click="backPage")
                  i.fas.fa-times
            br
        .columns
          h5.is-size-5
            small Cantidad Actual en Almacén: 
            span.tag.is-black.is-medium {{ cantidadActual }}
        .columns.is-vcentered
          .column.is-2
            .field
              label.label Cantidad
              .control
                input.input.is-primary(
                  type='number', 
                  placeholder='1',
                  v-model="cantidad",
                  min='1'
                )
          .column.is-2
            .field
              label.label Moneda
              .control.has-icons-left
                .select.is-dark.is-rounded
                  select(v-model="monedaSel" :disabled="isDisabled")
                    option(v-for="m in monedas" :key="m.id" :value="m.id") {{ m.prefijo }} {{ m.moneda }}
          .column.is-2
            .field
              label.label Precio Unit.
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='0.00',
                  v-model="precioUnitario",
                )
          .column.is-2
            .field
              input.is-checkradio.is-primary(type='checkbox'  id="checkCajaChica" v-model="cajaChica")
              label.is-size-6(for="checkCajaChica") Caja Chica
          .column.is-2(v-show="!cajaChica")
            .field
              label.label Orden de Compra
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Orden de Compra',
                  v-model="ordenCompra",
                )
          .column.is-2(v-show="!cajaChica")
            .field
              label.label No. Partida
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='',
                  v-model="partida",
                )
        .columns
          .column.is-2
            .field
              label.label Localización
              .control.has-icons-left
                .select.is-dark.is-rounded
                  select(v-model="localizacion" :disabled="isDisabled")
                    option(v-for="l in localizacionesFilter" :key="l.id" :value="l.id") {{ l.localizacion }}
          .column.is-2
            .field
              label.label Fecha de Compra:
              .control
                flat-pickr(
                  v-model='fechaCompra'
                  :config="config"
                  class="input is-primary"
                )
          .column.is-2
            .field
              label.label Factura
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='',
                  v-model="factura",
                )
          .column.is-offset-1.is-4
            .field
              label.label Proveedor
              Typeahead(:options="proveedores" :optionSelect="proveedorSel" :tema="tema" v-model="proveedorSel")
        .columns(v-show="datosFaltantes.length > 0")
          .column.is-12
            .notification
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns
          .column.is-12
            a.button.is-black.is-rounded(@click="chekForm") Guardar
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import Typeahead from './Typeahead'
  import FormProveedor from '../requisiciones_Componentes/FormProveedor.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import moment from 'moment'
  import { mapState } from 'vuex'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import 'flatpickr/dist/plugins/monthSelect/style.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"

  export default {
    name: 'UpdateConsumible',
    components: { Loader, NavBarInventario, flatPickr, Typeahead, FormProveedor },
    data() {
      return {
        isDisabled: false,
        isEditing: false,
        isSaved: false,
        isLoading: true,
        tipos: [],
        marcas: [],
        fechaReg: null,
        cantidad: 1,
        precioUnitario: null,
        ubicacion: null,
        ordenCompra: null,
        fechaCompra: moment().format('YYYY-MM-DD'),
        almacen: null,
        factura: '',
        cajaChica: false,
        itemSel: {},
        itemData: {},
        marcaSel: {},
        marcaData: {},
        almacenes: [],
        almacenesSel: [],
        config: {
          wrap: false, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only
        },
        typeMarca: 'marca',
        typeTipos: 'tipos',
        cantidadActual: 0,
        proveedores: [],
        proveedorSel: {},
        datosFaltantes: [],
        tema: 'proveedor',
        ubicaciones: [],
        origen: {},
        localizaciones: [],
        localizacionesFilter: [],
        localizacion: 0,
        partida: '',
        monedas: [],
        monedaSel: 1,
      }
    },
    watch: {
      ubicacion() {
        this.almacenesSel = this.almacenes.filter( alm => alm.id_ubicacion == this.ubicacion.id)
      },
      cantidad() {
        this.cantidadActual = parseInt(this.consumibleSelected.cantidad) + parseInt(this.cantidad)
      }
    },
    methods: {
      iniciarComponente() {
        InventarioServices.getMonedas()
          .then( data => {
            this.monedas = data.map(this.convetirMonedas)
            this.obtenerOrdenCompra()
          })
          .catch()
      },

      convetirMonedas(moneda) {
        return {
          ...moneda,
          id: parseInt(moneda.id)
        }
      },
      
      obtenerOrdenCompra () {
        let year = moment().format('YY')
        let month = moment().format('MM')
        this.ordenCompra = `GIA-${year}${month}-`
        this.obtenerProveedores()
      },

      obtenerUbicaciones() {
        InventarioServices.getUbicaciones()
          .then( data => {
            this.ubicaciones = data.map(this.convetirUbicaciones)
            this.obtenerAlmacenesConsumibles()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convetirUbicaciones (ubi) {
        return {
          ...ubi,
          id: parseInt(ubi.id)
        }
      },

      obtenerAlmacenesConsumibles() {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convetirAlmacenes)
            this.obtenerAlmacenOrigen()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convetirAlmacenes (alm) {
        return {
          ...alm,
          id: parseInt(alm.id),
          id_oficina: parseInt(alm.id_oficina),
          id_ubicacion: parseInt(alm.id_ubicacion),
          inventario: parseInt(alm.inventario),
        }
      },

      obtenerAlmacenOrigen () {
        this.almacenes.map( alm => {
          const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
          if (encontrado) {
            this.origen = alm
          }
        })
        this.obtenerLocalizaciones()
      },

      obtenerProveedores () {
        InventarioServices.getProveedores()
          .then( resp => {
            this.proveedores = resp.map(this.convertirATypeahead)
            this.obtenerUbicaciones()
          })
          .catch( e => console.log(e) )
          this.isLoading = false
      },

      convertirATypeahead(proveedor) {
        return {
          ...proveedor,
          text: `${proveedor.nombre}`
        }
      },

      chekForm () {
        this.datosFaltantes = []
        if (this.cantidad && this.precioUnitario) {
          this.saveConsumible()
        } else {
          if (!this.cantidad) {
            this.datosFaltantes.push('La cantidad es requerida.')
          }
          
          if (!this.precioUnitario) {
            this.datosFaltantes.push('El precio unitario es requerido.')
          } 
        }
      },

      saveConsumible () {
        this.isLoading = true
        let ahora = moment().format('YYYY-MM-DD HH:mm:ss')
        const id_Proveedor = Object.keys(this.proveedorSel).length > 0 ? this.proveedorSel.id : 0
        const cajaC = this.cajaChica ? 1 : 0

        InventarioServices.add_consumible_add(ahora, this.consumibleSelected.id, this.cantidad, this.precioUnitario, 
        this.origen.id_oficina, this.ordenCompra, this.fechaCompra, this.factura, id_Proveedor, this.userLogin.id, 
        this.userLogin.nombre, this.origen.id_resguardo, this.origen.resguardo, cajaC, this.localizacion, this.partida, this.monedaSel)
          .then( res => {
            if (res.success) {
              let id_movimiento = parseInt(res.getData)
              console.log(this.origen)
              console.log(this.origen.id_oficina)
              InventarioServices.add_consumible_movs(this.consumibleSelected.id,ahora,this.cantidad, id_movimiento, this.origen.id_oficina,this.userLogin.id,this.userLogin.nombre,this.origen.id_resguardo, this.origen.resguardo, 1)
                .then(data => {
                  console.log(data)
                    this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
                  if (data.success) {
                      this.backPage()
                  } else {
                    this.isLoading = false
                  }
                })
            } else {
              this.isLoading = false
              this.displayToast('bubble', data.respuesta,'ban', 'OK')
            }
          })
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema,
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backPage() {
        this.$router.back()
      },

      obtenerLocalizaciones() {
        InventarioServices.getLocalizaciones()
          .then( data => {
            this.localizaciones = data.map(this.convertirLocalizaciones)
            this.localizacionesFilter = this.localizaciones.filter( loc => loc.id_oficina == this.origen.id_oficina)
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convertirLocalizaciones(loc) {
        return {
          ...loc,
          id: parseInt(loc.id),
          id_oficina: parseInt(loc.id_oficina),
        }
      },
    },
    created () {
      this.cantidadActual = this.consumibleSelected.cantidad
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'consumibleSelected'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/UpdateConsumible.vue